import { OrderState } from "application/order/orderConstants";
import { createGenericListItemReducer } from "common/genericListItemReducer";
import reduceReducers from "reduce-reducers";
import { RequestState } from "./../../common/RequestState";
import {
  ORDERS_ME_RECEIVED,
  ORDERS_ME_REQUESTED,
  ORDERS_ME_REQUEST_FAILED,
  ORDER_BY_CODE_RECEIVED,
  ORDER_BY_CODE_REQUESTED,
  ORDER_BY_CODE_REQUEST_FAILED
} from "./orderActions";

const mapToObject = orders => {
  const result = {};
  orders.forEach(c => {
    c.requestState = RequestState.Finished;
    result[c.code] = c;
  });
  return result;
};

const mapPages = (state, pageSize, pageNumber, total, items) => {
  // remove saved pages if total or pageSize has changed
  if (state && state.total === total && state.pageSize === pageSize) return { ...state.pages, [pageNumber]: items };
  return { [pageNumber]: items };
};

function generatePayload(state, orderState, pageSize, pageNumber, total, items) {
  const pages = mapPages(state && state[orderState], pageSize, pageNumber, total, items.map(order => order.code));

  return {
    ...mapToObject(items),
    [orderState]: {
      pageSize: pageSize,
      total: total,
      pages: pages,
      requestState: RequestState.Finished
    }
  };
}

const initialState = {
  [OrderState.InProgress]: {
    requestState: RequestState.NotRequested
  },
  [OrderState.History]: {
    requestState: RequestState.NotRequested
  }
};

const createOrderReducer = () => (state = initialState, action) => {
  switch (action.type) {
    case ORDERS_ME_REQUESTED:
      return {
        ...state,
        ...action.payload,
        [action.orderState]: { ...state[action.orderState], requestState: RequestState.InProgress }
      };
    case ORDERS_ME_RECEIVED:
      const { orderState, pageSize, pageNumber, total, items } = action;
      return {
        ...state,
        ...generatePayload(state, orderState, pageSize, pageNumber, total, items)
      };
    case ORDERS_ME_REQUEST_FAILED:
      return {
        ...state,
        ...action.payload,
        [action.orderState]: {
          ...state[action.orderState],
          requestState: RequestState.Failed,
          correlationId: action.correlationId
        }
      };

    default:
      return state;
  }
};

export const orders = reduceReducers(
  createOrderReducer(),
  createGenericListItemReducer(ORDER_BY_CODE_REQUESTED, ORDER_BY_CODE_RECEIVED, ORDER_BY_CODE_REQUEST_FAILED)
);
